import { Button, DialogBody } from '@civilgrid/ui/components';
import { useForm } from 'react-hook-form';
import { capturePosthogEvent, POSTHOG_EVENTS } from '~/common/posthogEvents';
import Field from '~/pages/admin/common/Field';
import { homeMapStore as store } from '~/pages/homeViewV2/store';
import { validateCoordinates } from '../searchUtils';
import type { SearchComponentProps } from '.';

export function CoordinateSearch({ close }: SearchComponentProps) {
  const { control, watch } = useForm<{
    searchTerm: string;
  }>({
    defaultValues: {
      searchTerm: '',
    },
  });

  const parseCoordinates = (coord: string): [number, number] => {
    const parts = coord.split(',');
    return [parseFloat(parts[0]), parseFloat(parts[1])];
  };

  const searchTerm = watch('searchTerm');

  const coordinatesLabel = `${parseCoordinates(searchTerm)[0].toFixed(
    4,
  )}, ${parseCoordinates(searchTerm)[1].toFixed(4)}`;

  return (
    <DialogBody className="max-h-[75vh] max-w-full p-0 text-sm">
      <div className="flex w-full flex-col gap-4">
        <div className="flex flex-col space-y-1">
          <Field
            id="searchTerm"
            label="Enter Coordinates"
            control={control}
            placeholder="37.123, -122.123"
            tooltipText="enter coordinates in the format: `latitude, longitude` "
          />
          {searchTerm && searchTerm.length > 3 && !validateCoordinates(searchTerm) && (
            <div className="text-2xs text-red-700">Not Valid Coordinates</div>
          )}
        </div>
        <div className="flex justify-end">
          <Button
            data-testid="coordinate-search-navigate-button"
            disabled={!validateCoordinates(searchTerm)}
            onClick={() => {
              store.setAddressSearchResult({
                lngLat: parseCoordinates(searchTerm).reverse() as [number, number], // reverse so it is in lng, lat
                address: coordinatesLabel,
              });
              capturePosthogEvent(POSTHOG_EVENTS.coordinateSearched, {
                search_term: searchTerm,
              });
              close();
            }}
          >
            Navigate
          </Button>
        </div>
      </div>
    </DialogBody>
  );
}
